<template>
  <div class="row p-0 m-0">
    <div 
      v-if="!mobileDisplay"
      class="col-5 bg-image bg-wallpaper p-0 m-0"
    ></div>
    <div
      :class="{
        'col-12 bg-primary': mobileDisplay,
        'col-7': !mobileDisplay,
      }" 
      class="d-flex justify-content-center align-items-center vh-100">
      <login-form />
    </div>
  </div>
</template>
<script>
import LoginForm from './LoginForm.vue'
import { mapActions, mapState } from 'vuex';

export default {
  components: { LoginForm },
  computed: {
    ...mapState(['mobileDisplay'])
  },
  mounted() {
    this.logout()
  },
  methods: {
    ...mapActions(['logout'])
  },
}
</script>
<style>
.bg-wallpaper {
  background: linear-gradient(rgba(0, 0, 255, 0.4), rgba(0, 0, 255, 0.4)), url('../../assets/login/login-wallpaper.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
}
</style>